<script>
	import Helper from '../../Classes/Helper';
	import Widget from '../../Stores/Widget';

	export let config;
	let element = {};

	$: if (config.active) $Widget.current = element;
</script>

<style>
	div.zes-note {
		padding: 1em;
		margin-bottom: 1.5em;
		border-radius: .5em;
		background: hsl(0deg 0% 0% / .05);
	}

	div.zes-note-body {
		display: flex;
		align-items: center;
		gap: 1.5em;
	}

	div.zes-note-icon i {
		font-size: 3em;
		color: var(--zes-1-1);
	}

	div.zes-success div.zes-note-icon i {
		color: var(--zes-2-1);
	}

	div.zes-note-content {
		flex-grow: 1;
	}

	div.zes-note-title {
		font-size: 1.25em;
		font-weight: 600;
		color: var(--zes-1-2);
	}

	div.zes-success div.zes-note-title {
		color: var(--zes-2-2);
	}

	div.zes-note-description {
		font-size: .8em;
		color: var(--zes-3-1);
		margin-top: .25em;
	}

	div.zes-success div.zes-note-description {
		color: var(--zes-2-1);
	}

	div.zes-note > img {
		margin-top: 1em;
		border-radius: .5em;
	}
</style>

<div bind:this="{element}" class="zes-note" class:zes-success="{config.success}">
	<div class="zes-note-body">
		{#if config.icon}
			<div class="zes-note-icon">
				<i class="{config.icon}"></i>
			</div>
		{/if}
		<div class="zes-note-content">
			<div class="zes-note-title">{config.title}</div>
			{#if config.description}
				<div class="zes-note-description">{@html config.description}</div>
			{/if}
		</div>
	</div>
	{#if config.image}
		<img src="{Helper.image(config.image)}"/>
	{/if}
</div>